module.exports = __webpack_public_path__ + "static/media/light-r-3.43851cb5.png";